import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ChevronRightIcon, HomeIcon } from "@heroicons/react/outline";

const ProjectList = ({ projects = [] }) => {
  if (!projects || projects.length === 0) {
    return (
      <div className="card">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-slate-900 dark:text-white">
            Recent Projects
          </h3>
          <Link
            to="/projects"
            className="text-sm text-primary-500 hover:text-primary-600 dark:text-primary-400 dark:hover:text-primary-300"
          >
            View All
          </Link>
        </div>
        <div className="text-center py-8">
          <HomeIcon className="h-12 w-12 text-slate-300 dark:text-slate-600 mx-auto mb-2" />
          <p className="text-slate-500 dark:text-slate-400">No projects yet</p>
          <Link to="/projects/new" className="btn-primary mt-4 inline-block">
            Create Project
          </Link>
        </div>
      </div>
    );
  }

  const getStatusColor = (status) => {
    switch (status) {
      case "active":
        return "badge-success";
      case "planning":
        return "badge-info";
      case "on_hold":
        return "badge-warning";
      case "completed":
        return "badge-primary";
      case "cancelled":
        return "badge-danger";
      default:
        return "badge-info";
    }
  };

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-slate-900 dark:text-white">
          Recent Projects
        </h3>
        <Link
          to="/projects"
          className="text-sm text-primary-500 hover:text-primary-600 dark:text-primary-400 dark:hover:text-primary-300 flex items-center gap-1"
        >
          View All
          <ChevronRightIcon className="h-4 w-4" />
        </Link>
      </div>
      <div className="space-y-3">
        {projects.slice(0, 5).map((project, index) => (
          <motion.div
            key={project.id}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: index * 0.05 }}
          >
            <Link
              to={`/projects/${project.id}`}
              className="flex items-center justify-between p-3 rounded-lg hover:bg-slate-50 dark:hover:bg-slate-700/50 transition-colors group"
            >
              <div className="flex items-center gap-3 min-w-0">
                <div className="w-10 h-10 bg-primary-50 dark:bg-primary-900/20 rounded-lg flex items-center justify-center flex-shrink-0">
                  <HomeIcon className="h-5 w-5 text-primary-500" />
                </div>
                <div className="min-w-0">
                  <p className="text-sm font-medium text-slate-900 dark:text-white truncate">
                    {project.name}
                  </p>
                  <p className="text-xs text-slate-500 dark:text-slate-400">
                    {project.client_name || "No client"} •{" "}
                    {project.location || ""}
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-3 flex-shrink-0">
                <span className={`badge ${getStatusColor(project.status)}`}>
                  {project.status || "Planning"}
                </span>
                <ChevronRightIcon className="h-4 w-4 text-slate-400 group-hover:text-primary-500 transition-colors" />
              </div>
            </Link>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ProjectList;
